import React, { useEffect } from "react";
import { XCircle, CheckCircle, Info, AlertTriangle, X } from "lucide-react";

const ICONS = {
  success: <CheckCircle className="w-5 h-5 text-green-500" />,
  error: <XCircle className="w-5 h-5 text-red-500" />,
  info: <Info className="w-5 h-5 text-blue-500" />,
  warning: <AlertTriangle className="w-5 h-5 text-yellow-500" />,
};

const ToastNotification = ({
  show,
  message,
  type = "info",
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    if (show && type !== "loading") {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, type, duration, onClose]);

  if (!show) return null;

  return (
    <div
      className={`fixed top-5 right-5 flex items-center space-x-3 p-4 rounded-lg shadow-lg bg-white border-l-4
      ${type === "success" ? "border-green-500" : ""}
      ${type === "error" ? "border-red-500" : ""}
      ${type === "info" ? "border-blue-500" : ""}
      ${type === "warning" ? "border-yellow-500" : ""}
    `}
    >
      {ICONS[type]}
      <span className="text-gray-800">{message}</span>
      <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ToastNotification;
